<template>
  <div class="practice-result">
    <div class="result-top-con">
      <div class="result-info-con">
        <p class="result-title">
          {{
            typeOfPractice == 'FLASHCARDS' ? $t('flashcard_completed') : $t('practice_completed')
          }}
        </p>
        <p class="info-item">
          {{ $t('practice_spent_minutes', { duration: practiceResult?.answer_time || 1 }) }}
        </p>
        <p class="info-item">{{ $t('the_level') }}: {{ levelName }}</p>
      </div>
      <div class="progress-con">
        <div class="progress-txt" :class="svgText">
          {{ $t('practice_result_progress_txt') }}
        </div>
        <div class="progress-percent">{{ progress }}<span class="symbol">%</span></div>
        <svg viewBox="22 22 44 44" class="cirlce-con">
          <circle
            id="result-progress"
            cx="44"
            cy="44"
            :r="progressR"
            fill="none"
            stroke="#fff"
            stroke-width="3.6"
          ></circle>
        </svg>
      </div>
      <md-button class="md-icon-button close-icon" @click="closeDialog">
        <img src="@/assets/images/free-practice/simple_close.png" class="header-close" />
      </md-button>
    </div>
    <div class="result-detail-con">
      <p class="detail-title">{{ $t('practice_result_summary') }}</p>
      <div class="detail-line">
        <p class="detail-type">{{ practiceType }}</p>
        <div class="characters-con">
          <span
            v-for="item in practiceResult?.answer_list"
            :key="item.id"
            class="characters"
            :style="{ color: answerStatusColor[item.user_answer_status] }"
            >{{ item.characters }}{{ item.id == lastWordId ? '' : '、' }}</span
          >
        </div>
        <div class="detail-score">
          {{ practiceResult.answer_rate }}
          <span class="grey-txt"
            >({{ $t('evaluate_common_total_score') }}:{{ correctCount }}/{{ answerListLen }})</span
          >
        </div>
      </div>
    </div>
    <div class="result-bottom-left">
      <p class="example-item example-item-green">{{ $t('free_practice_correct') }}</p>
      <p class="example-item example-item-red">{{ $t('practice_wrong') }}</p>
      <p class="example-item example-item-grey" v-if="typeOfPractice == 'FLASHCARDS'">
        {{ $t('practice_skip') }}
      </p>
    </div>
    <div class="result-bottom-right">
      <div class="fp-button fp-submit-btn" @click="closeDialog">
        {{ $t('practice_done') }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    levelName: {
      type: String,
      default: 'HSK1',
    },
    practiceResult: {
      type: Object,
      default: () => {},
    },
    typeOfPractice: {
      type: String,
      default: 'FLASHCARDS',
    },
    answerKey: {
      type: String,
      default: 'FLASHCARDS',
    },
    questionKey: {
      type: String,
      default: 'FLASHCARDS',
    },
    exerciseKey: {
      type: String,
      default: 'FLASHCARDS',
    },
    correctCount: {
      type: Number || String,
      default: 0,
    },
    answerTime: {
      type: Number || String,
      default: 1,
    },
  },
  data() {
    return {
      progressR: 20,
      animationProgress: 0,
      transKeysName: [
        {
          title: 'vocab_translate',
          key: 'Meaning',
        },
        {
          title: 'free_practice_sound',
          key: 'Sound',
        },
        {
          title: 'vocabulary',
          key: 'Characters',
        },
        {
          title: 'vocab_pinyin',
          key: 'Pinyin',
        },
        {
          title: 'free_practice_exercise_select',
          key: 'Choice',
        },
        {
          title: 'free_practice_exercise_Pairs',
          key: 'Pairs',
        },
        {
          title: 'free_practice_exercise_TF',
          key: 'Judge',
        },
      ],
      answerStatusColor: {
        0: '#B5B5BE',
        1: '#39B38E',
        2: '#B33939',
      },
    }
  },
  methods: {
    setProgress(percent) {
      let dom = document.getElementById('result-progress')
      const perimeter = 2 * Math.PI * this.progressR
      const offset = perimeter - (percent / 100) * perimeter
      dom.style.strokeDasharray = perimeter
      dom.style.strokeDashoffset = offset
      if (this.animationProgress < this.progress) {
        this.animationProgress++
        if (this.animationProgress >= this.progress) {
          this.animationProgress = this.progress
        }
        requestAnimationFrame(() => {
          this.setProgress(this.animationProgress)
        })
      }
    },
    getTranceName(key) {
      let obj = this.transKeysName.find((item) => item.key == key)
      return obj.title && this.$t(obj.title)
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
  },
  mounted() {
    this.setProgress(this.animationProgress)
  },
  computed: {
    svgText() {
      let local = localStorage.getItem('language')
      if (local == 'fr' || local == 'vi') {
        return 'progress-sml-font'
      }
      return 'progress-txt'
    },
    answerListLen() {
      if (this.practiceResult.answer_list) {
        return this.practiceResult.answer_list.length
      }
      return 0
    },
    lastWordId() {
      if (this.answerListLen > 0) {
        return this.practiceResult.answer_list[this.answerListLen - 1].id
      }
      return ''
    },
    progress() {
      if (this.practiceResult.answer_rate) {
        let matchArr = this.practiceResult.answer_rate.match(/[0-9]*/i)
        if (matchArr && matchArr.length > 0) {
          return matchArr[0]
        }
      }
      return 0
    },
    practiceType() {
      /**FLASHCARDS question-answer
       * Exercise exercise
       */
      if (this.typeOfPractice == 'FLASHCARDS') {
        let questionTrans = this.getTranceName(this.questionKey)
        let answerTrans = this.getTranceName(this.answerKey)
        return questionTrans + '-' + answerTrans
      } else {
        let exerciseTrans = this.getTranceName(this.exerciseKey)
        return exerciseTrans
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import './styles/freePractice';
.practice-result {
  position: relative;
  .result-top-con {
    height: 260px;
    background-position: 50%;
    background-size: cover;
    background-image: url(~@/assets/images/free-practice/flashcard-result-bg.png);
    -webkit-user-select: none;
    user-select: none;
    position: relative;
    margin-top: -1px;
    .close-icon {
      position: absolute;
      right: 24px;
      top: 14px;
      .header-close {
        margin-top: 3px;
      }
    }
    .result-info-con {
      padding-top: 66px;
      padding-left: 305px;
      .result-title {
        font-size: 36px;
        color: #fff;
        margin-bottom: 35px;
      }
      .info-item {
        font-size: 16px;
        color: #fff;
        margin-bottom: 8px;
        font-weight: 400;
      }
    }
    .progress-con {
      position: absolute;
      right: 109px;
      top: 66px;
      width: 128px;
      height: 128px;
      background: rgba(74, 84, 129, 0.1);
      border-radius: 50%;
      text-align: center;
      .progress-txt {
        display: flex;
        align-items: start;
        justify-content: center;
        color: #fff;
        padding-top: 22px;
        height: 52px;
        font-size: 18px;
        width: 80%;
        margin: auto;
        word-break: break-word;
      }
      .progress-sml-font {
        font-size: 13px;
        align-items: center;
      }
      .progress-percent {
        font-size: 44px;
        line-height: 44px;
        font-weight: 600;
        color: #fff;
      }
      .symbol {
        font-size: 16px;
      }
      .cirlce-con {
        transform: rotate(-90deg);
        width: 128px;
        height: 128px;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
  .result-detail-con {
    background: #fff;
    height: 338px;
    padding: 24px;
    .detail-title {
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      color: #2c2f46;

      margin-top: 12px;
    }
    .detail-line {
      display: flex;
      padding: 24px 20px 18px;
      border-bottom: 1px solid #dfdfdf;
      justify-content: space-between;
      align-items: center;
      .detail-type {
        font-size: 18px;
        font-weight: 600;
        color: #2c2f46;
        min-width: 150px;
        max-width: 180px;
        word-wrap: break-word;
      }
      .characters-con {
        width: 420px;
        word-break: keep-all;
        text-align: center;
      }
      .characters {
        font-size: 16px;
        color: #b5b5be;
        letter-spacing: 2px;
      }
      .detail-score {
        font-size: 16px;
        font-weight: 600;
        color: #39b38e;
        min-width: 150px;
        text-align: right;
        .grey-txt {
          font-weight: 500;
          color: #696974;
        }
      }
    }
  }
  .result-bottom-left {
    position: absolute;
    left: 60px;
    bottom: 11px;
    display: flex;
    align-items: center;
    .example-item {
      height: 17px;
      line-height: 17px;
      font-size: 14px;
      font-weight: bold;
      position: relative;
      margin-right: 52px;
      color: #b5b5be;
    }
    .example-item::before {
      position: absolute;
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #b5b5be;
      left: -16px;
      top: 4px;
      transform: translateX(-50%);
    }
    .example-item-green {
      color: #39b38e;
    }
    .example-item-green::before {
      background: #39b38e;
    }
    .example-item-red {
      color: #b33939;
    }
    .example-item-red::before {
      background: #b33939;
    }
  }
  .result-bottom-right {
    position: absolute;
    right: 24px;
    bottom: 0px;
  }
}
</style>
